// Timestamps are stored in UTC; display always uses the organization's timezone.

let orgTimezone = 'Asia/Karachi';
export const setDisplayTimezone = (tz) => { if (tz) orgTimezone = tz; };
export const getDisplayTimezone = () => orgTimezone;

export function formatDateTime(value, { timeZone = orgTimezone, withTime = true } = {}) {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat('en-GB', {
    timeZone, day: '2-digit', month: 'short', year: 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit', hour12: false } : {}),
  }).format(d);
}

export const formatDate = (value, opts = {}) => formatDateTime(value, { ...opts, withTime: false });

export function relativeTime(value, now = Date.now()) {
  if (!value) return '';
  const diff = (new Date(value).getTime() - now) / 1000;
  const abs = Math.abs(diff);
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  if (abs < 45) return 'just now';
  if (abs < 3600) return rtf.format(Math.round(diff / 60), 'minute');
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), 'hour');
  if (abs < 86400 * 7) return rtf.format(Math.round(diff / 86400), 'day');
  return formatDate(value);
}

/** Parts of the current time in a timezone (used by the login clock). */
export function zonedTimeParts(date, timeZone) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  }).formatToParts(date);
  const get = (t) => Number(parts.find((p) => p.type === t)?.value ?? 0);
  return { hours: get('hour') % 24, minutes: get('minute'), seconds: get('second') };
}

export const isValidTimezone = (tz) => {
  try { new Intl.DateTimeFormat('en', { timeZone: tz }); return true; } catch { return false; }
};
